import { LogManager } from '../../../common/port/log/log.manager.port';
import { AccountMetricsInsightsTimeInAppSummaryEntityMapper } from '../../../infrastructure/mappers/challenge-insights/account-metrics-insights-time-in-app-summary.entity.mapper';
import { GetAccountMetricsInsightsTimeInAppSummaryRequestDto } from '../../dtos/challenge-insights/get-account-metrics-insights-time-in-app-summary.request.dto';
import { GetAccountMetricsInsightsTimeInAppSummaryResponseDto } from '../../dtos/challenge-insights/get-account-metrics-insights-time-in-app-summary.response.dto';
import { GetAccountMetricsInsightsTimeInAppSummaryQuery } from '../../queries/challenge-insights/get-account-metrics-insights-time-in-app-summary.query';

export class GetAccountMetricsInsightsTimeInAppSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountMetricsInsightsTimeInAppSummaryQuery,
    protected readonly mapper: AccountMetricsInsightsTimeInAppSummaryEntityMapper
  ) {}

  async get(
    props: GetAccountMetricsInsightsTimeInAppSummaryRequestDto
  ): Promise<GetAccountMetricsInsightsTimeInAppSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountMetricsInsightsTimeInAppSummaryController.get encountered an error ${error}`
      );
    }
  }
}
